<template>
  <div
    class="
      col-md-4
      justify-content-center
      pull-left
      px-0
      pr-md-4
      rounded-0
      profile-sidebar
      bg-white
      pb-4
    "
  >
    <VueSlickCarousel ref="slick" v-bind="settings">
      <b-col class="profile-sidebar-option" v-for="(link, l) in links" :key="`link-${l}`">
        <router-link
          :to="link.route"
          :class="activeNavItem(link.route)"
          class="d-block font-weight-bold w-100 option-link py-3 h6 mb-0"
        >
          <span class="text-primary-lightest"></span> {{ link.label }}
        </router-link>
      </b-col>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      settings: {
        arrows: true,
        variableWidth: true,
        infinite: false,
        focusOnSelect: true,
        centerMode: false,
        centerPadding: "50px",
        responsive: [
          {
            breakpoint: 9999,
            settings: "unslick",
          },
          {
            breakpoint: 768,
          },
        ],
      },
    };
  },
  props: {
    links: Array,
  },
  methods: {
    activeNavItem(route) {
      return this.$route.path === route ? "active" : "";
    },
    activeNavItemIndex() {
      return this.links.findIndex((link) => link.route === this.$route.path);
    },
  },
  mounted() {
    if (this.isMobile) {
      this.$refs.slick.goTo(this.activeNavItemIndex(), true);
    }
  },
};
</script>

<style lang="scss" scoped>
.profile-sidebar-option {
  border-bottom: 1px solid $color-light;
  &:last-child {
    border: none;
  }
}
.option-link {
  color: $color-dark;
  text-decoration: none;
  &:hover,
  &.active {
    color: $color-blue;
  }
}
::v-deep .slick-disabled {
  display: none !important;
  & + {
    .slick-list {
      padding-left: 0;
      &:before {
        display: none;
      }
    }
  }
}
::v-deep .slick-list {
  padding: 0 40px;

  &:before,
  &:after {
    content: "";
    width: 56px;
    height: 56px;
    display: block;
    background: rgb(255, 255, 255);
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
  }
  &:after {
    background: rgb(255, 255, 255);
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 1) 50%);
    right: 0;
    left: auto;
  }
}

::v-deep .slick-arrow {
  position: absolute;
  z-index: 9;
  left: 12px;
  top: 12px;
  background: none;
  border: none;
  font-size: 0;
  text-indent: -9999px;
  border: 2px solid $color-orange;
  width: 30px;
  height: 30px;
  border-radius: 100%;

  &.slick-next {
    left: auto;
    right: 12px;
    transform: rotate(180deg);
  }

  &:before,
  &:after {
    content: "";
    width: 2px;
    height: 7px;
    display: block;
    position: absolute;
    transform: rotate(-40deg);
    background: $color-orange;
    left: 11px;
    top: 12px;
  }

  &:after {
    top: 7px;
    transform: rotate(40deg);
  }
}
</style>
